import React from 'react';

// Create function to display Welcome page
function Welcome() {
    return (
        <div className="welcome">
            <h1>Welcome to Minesweeper! Pick an option from the menu above</h1>
        </div>
    );
}

// Export component so it can be used by App.js
export default Welcome;